import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const SCHEDULED_REBALANCING_TIMEZONES_QUERY_KEY =
  'scheduled-rebalancing-timezones';

const getTimeZonesQueryOptions = () =>
  queryOptions({
    queryKey: [SCHEDULED_REBALANCING_TIMEZONES_QUERY_KEY],
    queryFn: async () => {
      const { data } = await apiClient.scheduledRebalancing.listTimeZones();
      return data?.timeZones || null;
    },
  });

export const useTimeZonesQuery = () => {
  const { isLoading, data, error } = useQuery(getTimeZonesQueryOptions());

  return {
    isLoading,
    timeZones: data || undefined,
    error,
  };
};
